var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpChevronGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5255 10.7437C3.17652 11.0854 2.61071 11.0854 2.26173 10.7437C1.91276 10.402 1.91276 9.84799 2.26173 9.50628L7.36812 4.50628C7.7171 4.16457 8.2829 4.16457 8.63188 4.50628L13.7383 9.50628C14.0872 9.84799 14.0872 10.402 13.7383 10.7437C13.3893 11.0854 12.8235 11.0854 12.4745 10.7437L7.99756 6.36004L3.5255 10.7437Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4773_64548",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 12,
    height: 7
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5255 10.7437C3.17652 11.0854 2.61071 11.0854 2.26173 10.7437C1.91276 10.402 1.91276 9.84799 2.26173 9.50628L7.36812 4.50628C7.7171 4.16457 8.2829 4.16457 8.63188 4.50628L13.7383 9.50628C14.0872 9.84799 14.0872 10.402 13.7383 10.7437C13.3893 11.0854 12.8235 11.0854 12.4745 10.7437L7.99756 6.36004L3.5255 10.7437Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4773_64548)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 16,
    width: 16,
    height: 16,
    transform: "rotate(-180 16.25 16)",
    fill: "#BAC0CB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpChevronGrey);
export default __webpack_public_path__ + "static/media/up-chevron-grey.11cb99da2cbfbe3bf5ca77b3aec6e038.svg";
export { ForwardRef as ReactComponent };